import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JSONApiShowResponse } from '@app/interfaces';
import { TimeClockEntry } from '@app/models/time-tracking/time-clock-entry.model';
import { TimeTrackingResources } from '../time-tracking.resource';

@Injectable({
    providedIn: 'root',
})
export class TimeClockService {
    constructor(private http: HttpClient) {}

    getLatestActiveEntry(): Promise<JSONApiShowResponse<TimeClockEntry>> {
        const url = TimeTrackingResources.LatestActiveEntry;
        return this.http.get<JSONApiShowResponse<TimeClockEntry>>(url).toPromise();
    }
}
